export const authGroupSelector = state => state.entities.authGroups;
